module.exports = __webpack_public_path__ + "static/media/img-preview-phone.ad786d73.png";